import React from 'react'
import { string, bool, element } from 'prop-types'
import { Button } from '@livechat/design-system-react-components'

import { isAgentApp, navigateToIFrame } from '@/utils'

/*
  Temporary solution for Chatbot product:
*/
export const InstallPopUpButton = ({
  icon,
  disabled,
  className,
  size,
  fullWidth,
}) => {
  const handleOnClick = (e) => {
    const chatbotUrl = `${process.env.GATSBY_LC_IFRAME_URL}/team/chatbots?addBot=true`

    if (isAgentApp) {
      navigateToIFrame(e, `/team/chatbots?addBot=true`)
    } else {
      window.open(chatbotUrl, '_blank')
    }
  }

  return (
    <Button
      data-test="install-btn"
      icon={icon || ''}
      disabled={disabled}
      onClick={handleOnClick}
      className={className}
      size={size}
      kind="primary"
      fullWidth={fullWidth}
    >
      Get
    </Button>
  )
}

InstallPopUpButton.propTypes = {
  icon: element,
  disabled: bool,
  className: string,
  size: string,
  fullWidth: bool,
}

export default InstallPopUpButton
